/*
 * ContactUsModal
 */

import { connect } from 'react-redux';
import { WithTranslation, withTranslation } from 'react-i18next';
import { toggleContactUsModal } from '../../actions/userActions';
import { IinitialState } from '../../reducers';
import * as React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { IfacilityWithoutBuildings } from '../../models';

interface Iprops {
    show: boolean;
    toggleModal: () => void;
    selectedFacility: IfacilityWithoutBuildings;
}

class ContactUsModal extends React.Component<Iprops & WithTranslation> {
    render() {
        const { show, toggleModal, selectedFacility } = this.props;
        const contacts = selectedFacility?.contacts;

        return (
            <Modal
                show={show}
                onHide={toggleModal}
                className="contact-us-modal"
            >
                <Modal.Header>
                    <Modal.Title>CONTACT US</Modal.Title>
                    <button
                        type="button"
                        className="close"
                        onClick={toggleModal}
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    {selectedFacility?.name && (
                        <div className="facility-name-header">
                            <strong>Facility:</strong> {selectedFacility.name}
                        </div>
                    )}
                    <p className="modal-description">
                        Contact our support team for assistance with equipment,
                        service requests,
                        <br /> or general inquiries.
                    </p>
                    {contacts ? (
                        <div className="equipment-contacts">
                            {contacts.emergencyNumber && (
                                <div className="equipment-contact-row">
                                    <span className="contact-label">
                                        Emergency Number:
                                    </span>
                                    <span className="contact-value">
                                        {contacts.emergencyNumber}
                                    </span>
                                </div>
                            )}
                            {contacts.serviceSales && (
                                <div className="equipment-contact-row">
                                    <span className="contact-label">
                                        Service Sales:
                                    </span>
                                    <span className="contact-value">
                                        {contacts.serviceSales}
                                    </span>
                                </div>
                            )}
                            {contacts.equipmentSales && (
                                <div className="equipment-contact-row">
                                    <span className="contact-label">
                                        Equipment Sales:
                                    </span>
                                    <span className="contact-value">
                                        {contacts.equipmentSales}
                                    </span>
                                </div>
                            )}
                            {contacts.leadTechnician1 && (
                                <div className="equipment-contact-row">
                                    <span className="contact-label">
                                        Lead Technician #1:
                                    </span>
                                    <span className="contact-value">
                                        {contacts.leadTechnician1}
                                    </span>
                                </div>
                            )}
                            {contacts.leadTechnician2 && (
                                <div className="equipment-contact-row">
                                    <span className="contact-label">
                                        Lead Technician #2:
                                    </span>
                                    <span className="contact-value">
                                        {contacts.leadTechnician2}
                                    </span>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div className="no-contacts">
                            No contacts available for this facility.
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="info" onClick={toggleModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

const mapStateToProps = (state: IinitialState) => {
    const selectedFacilityID = state.selectedFacilityID;
    const selectedFacility = state.facilities[selectedFacilityID];

    return {
        show: state.showContactUsModal,
        selectedFacility: selectedFacility || { contacts: undefined }
    };
};

export default withTranslation('common')(
    connect(mapStateToProps, {
        toggleModal: toggleContactUsModal
    })(ContactUsModal)
);
